// extracted by mini-css-extract-plugin
export var divider = "_cr-7";
export var itemsToggle = "_cr-8";
export var mergeModal = "_cr-1";
export var optionCard = "_cr-4";
export var radioGroup = "_cr-6";
export var radioOption = "_cr-0";
export var selected = "_cr-5";
export var shipmentOptions = "_cr-2";
export var tableOptions = "_cr-3";